import { render, staticRenderFns } from "./lkuBudgetinternal.vue?vue&type=template&id=53933cb8"
import script from "./lkuBudgetinternal.vue?vue&type=script&lang=js"
export * from "./lkuBudgetinternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports